import React, { useState } from 'react';
import { Modal, Input, Button, Alert, Form, Typography, Spin } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useAuth } from './AuthContext';

const ForgotPasswordDialog = ({ open, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  
  const { resetPassword } = useAuth();

  // 确保open属性始终为布尔值
  const isOpen = Boolean(open);

  const handleSubmit = async (values) => {
    try {
      setError('');
      setLoading(true);
      await resetPassword(values.email);
      setSuccess(true);
    } catch (err) {
      setError('重置密碼請求失敗，請檢查您的郵箱地址');
      console.error('重置密碼失敗:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    form.resetFields();
    setError('');
    setSuccess(false);
    if (onClose) onClose();
  };

  return (
    <Modal
      title="重置密碼"
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      destroyOnClose
      width={400}
    >
      {success ? (
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <Alert
            message="重置密碼鏈接已發送"
            description="重置密碼鏈接已發送到您的郵箱，請查收。"
            type="success"
            showIcon
            style={{ marginBottom: 20 }}
          />
          <Button type="primary" onClick={handleClose}>
            關閉
          </Button>
        </div>
      ) : (
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
        >
          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              style={{ marginBottom: 16 }}
            />
          )}
          
          <Form.Item
            label="郵箱地址"
            name="email"
            rules={[
              { required: true, message: '請輸入郵箱地址' },
              { type: 'email', message: '請輸入有效的郵箱地址' }
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="請輸入您的郵箱地址"
              size="large"
              disabled={loading}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
            <Button onClick={handleClose} disabled={loading} style={{ marginRight: 8 }}>
              取消
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              icon={loading ? <Spin size="small" /> : null}
            >
              發送重置鏈接
            </Button>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default ForgotPasswordDialog; 